import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import mutationWrapper from "../../mutationWrapper";
import getQueryClient from "../../queryClient";
import { AddKontakReferensi } from "../../../../models/KontakReferensi";
import { allKontakReferensiKey } from "./useFetchKontakReferensi";
import { checkProfileKey } from "../../queries/User/useFetchCheckProfile";

export async function addKontakReferensi(data: AddKontakReferensi) {
    const res = await ApiClient.post(`/AddReferenceContact`, data);
    return res.data;
}

export const useAddKontakReferensi = mutationWrapper(addKontakReferensi, {
    onSuccess: () => {
        getQueryClient().invalidateQueries(allKontakReferensiKey);
        getQueryClient().invalidateQueries(checkProfileKey)
    },
});
